import React from "react"
import { graphql } from "gatsby"

import ImageText from "components/sections/ImageText"
import AdvisorsGrid from "components/sections/AdvisorsGrid"
import NewsCarousel from "components/sections/NewsCarousel"
import Twitter from "components/sections/Twitter"

import Layout from "components/Layout"
import SEO from "components/Seo"
import { colors } from "utils/styled-constants"

const PortfolioPage = ({ data }) => {
  console.log("DATA: ", data)
  const site = data.contentfulSite

  const {
    name,
    sector,
    description,
    logo,
    featuredImage,
    website,
    twitterUsername,
    founderGrid,
    newsCarousel,
  } = data.contentfulPortfolioCompany
  const heroBackground = data.heroBackground.childImageSharp
  const twitterBackground = data.twitterBackground.childImageSharp

  return (
    <Layout header={site.header}>
      <SEO siteTitle={site.title} title={name} />
      <ImageText
        sectionStyling={{
          backgroundColor: "white",
          accentImage: heroBackground,
        }}
        sectionText={{
          title: name,
          subtitle: sector,
          description: description,
          subtitleFontStyle: "italic",
          subtitleColor: colors.lightBlue,
        }}
        image={featuredImage}
        overlaidImage={logo}
        imageLocation="left"
        button={{
          link: { externalLink: website },
          text: "View website",
        }}
      />
      {founderGrid && <AdvisorsGrid {...founderGrid} />}
      {newsCarousel && <NewsCarousel {...newsCarousel} />}
      {twitterUsername && (
        <Twitter
          section={{
            backgroundColor: "gray",
            accentImage: twitterBackground,
          }}
          username={twitterUsername}
          twitterCardsShadow={null}
          button={{
            variant: "white",
            link: { externalLink: `https://twitter.com/${twitterUsername}` },
            text: `@${twitterUsername}`,
          }}
        />
      )}
    </Layout>
  )
}

export default PortfolioPage

export const query = graphql`
  query PortfolioCompanyBySlug($slug: String!) {
    heroBackground: file(
      relativePath: { eq: "company-hero-background-desktop.png" }
    ) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    twitterBackground: file(
      relativePath: { eq: "twitter-feed-background-desktop.png" }
    ) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    contentfulPortfolioCompany(slug: { eq: $slug }) {
      name
      sector
      description {
        childMarkdownRemark {
          html
        }
      }
      logo {
        fluid(maxWidth: 300) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      featuredImage {
        fluid(maxWidth: 500) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      twitterUsername
      website
      founderGrid {
        ...AdvisorsGrid
      }
      newsCarousel {
        ...NewsCarousel
      }
    }
    contentfulSite {
      title
      header {
        ... on ContentfulDefaultHeader {
          ...DefaultHeader
        }
      }
    }
  }
`
